import React, { useState, useEffect } from 'react';
import cookie from 'react-cookies';
import { toast } from 'react-toastify';
import ArrowLeftCircle from '../atoms/icons/ArrowLeftCircle';
import { useTranslate } from '../../translate/I18n';
import Button from '../elements/Button';
import CookiePolicyForm from './CookiePolicyForm';
import { getAgreementCookies } from '../../utils/cookies';
import { COOKIES } from '../../constants';
import { commonRoutes } from '../../routes';
import Link from '../atoms/Link';
import { useRouter } from '../../utils/router';
import { useCookieContext } from '../auth/hook/CookieContext';
import { translateRoute } from '../../routesActions/routeHelper';

const { AGREEMENTS, USER_GLOBAL_AGREEMENT } = COOKIES;

const CoockiePolicyPage = () => {
  const { enableOrDisableBasedOnCookie: enableOrDisableBasedOnCookieNextjs } = useCookieContext();
  const { t, i18n } = useTranslate(['notificationSuccess', 'legalPages', 'cookiesPolicy']);
  const [initialValues, setInitialValues] = useState();
  const history = useRouter();

  useEffect(() => {
    const agreementCookies = getAgreementCookies();
    const initialValues = {};

    for (const cookieName of AGREEMENTS) {
      initialValues[cookieName] = agreementCookies.includes(cookieName);
    }
    setInitialValues(initialValues);
  }, []);

  const updateCookies = (cookiesObject) => {
    const acceptedCookies = Object.keys(cookiesObject).filter(cookie => cookiesObject[cookie]);
    const userHasAcceptedAllCookies = acceptedCookies.length === AGREEMENTS.length;

    AGREEMENTS.forEach(key => {
      cookie.save(key, acceptedCookies.includes(key), { path: '/' });
    });
    cookie.save(USER_GLOBAL_AGREEMENT, userHasAcceptedAllCookies, { path: '/' });

    enableOrDisableBasedOnCookieNextjs();
    toast.success(t('notificationSuccess:auth.cookiesUpdated'));
  };

  return (
    <section className="section__search col-12 p mb">
      <div className="container__center">
        <div className="col-12 col-10-md p m-auto">
          <Button onClick={() => history.goBack()} className="btn-md transparent trimmed ph-none t-grey-dark block">
            <ArrowLeftCircle />
            {t('common:back')}
          </Button>
          <h2>{t('cookiesPolicy:title')}</h2>
        </div>
        <div className="col-12 col-10-md p m-auto">
          <CookiePolicyForm cookies={AGREEMENTS} initialValues={initialValues} updateCookies={updateCookies} />
          <div className="t-center mt">
            <Link className="link" to={translateRoute(commonRoutes.legal.privacyPolicy.to, 'en', i18n.language)}>
              {t('common:moreInformation')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoockiePolicyPage;
